export default "__VITE_ASSET__BrSIZHfU__"